// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { map } from 'lodash/fp';

export const capMap = map.convert({ cap: false });
